import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SafeUrl } from '@angular/platform-browser';

import { GreyhoundParticipantInfo, WinGameParticipant } from '@frontend/sports/racing/feature/models';
import { Observable } from 'rxjs';

import { RacingService } from '../../../services/racing-service';

@Component({
    selector: 'ms-gh-trap-images',
    templateUrl: './gh-trap-images.component.html',
    standalone: false,
})
export class GhTrapImagesComponent {
    trapImages$: Observable<{ [key: string]: SafeUrl }>;
    @Input() greyhoundTrapDogMapping: { [id: number]: GreyhoundParticipantInfo } = {};
    @Input({ required: true }) participant: WinGameParticipant;
    @Input() isOptionBet = false;

    constructor(private racingService: RacingService) {
        this.trapImages$ = this.racingService.getTraps$.pipe(takeUntilDestroyed());
    }

    getBackgroundImage(trapImages: { [key: string]: SafeUrl }): SafeUrl {
        if (this.isOptionBet) {
            return this.greyhoundTrapDogMapping[this.participant.participantId].trapNumber !== undefined
                ? trapImages[this.greyhoundTrapDogMapping[this.participant.participantId].trapNumber]
                : '';
        }
        return trapImages[this.participant.participantId];
    }
}
